export enum ESubscriptionStatus
{
    Active, //Paid claim
    PaymentError,//Paid claim -> info popup should be displayed
    Inactive//Unpaid claim -> page for paying should be displayed
}
